const HISTORY_FEED = {
    HISTORY_FEED_OPTION: 'history-feed-option',
};

const TIMER_FEED = {
    TIMER_FEED_OPTION: 'timer-feed-option',
};

const COMPONENTS = {
    FULLSCREEN_MODAL: 'fullscreen-modal',
    STATUS_ROW: 'status-row',
    CALENDAR_DISPLAY_DATA: 'calendar-display-date',
    CALENDAR: 'calendar',
};

const MANAGE_SETTINGS = {
    GOAL_STATUS_SELECTOR: 'goal_status_selector',
    GOAL_SELECTOR: 'goal-selector',
    OPEN_EDIT_GOALS_MODAL: 'open-edit-goals-modal',
    OPEN_DISCARD_CHANGES_MODAL: 'open-discard-changes-modal',
    MODAL_TAG_CLIENT_NAME: 'modal-client-name',
    MODAL_TAG_ACCOUNT_NAME: 'modal-account-name',
    MODAL_DELETE_BUTTON: 'modal-delete-button',
    MODAL_DELETE_TITLE: 'modal-delete-title',
    MODAL_CANCEL_BUTTON: 'modal-cancel-button',
    MODAL_CREATE_BUTTON: 'modal-create-button',
    ADD_GOALS: 'company-add-goals',
    COMPANY_GOALS_HEADER: 'company-goals-header',
    COMPANY_DISPLAY_GOALS: 'company-display-goals',
    COMPANY_KPI_PLATFORM_SELECT: 'company-kpi-platform-select',
    TOTAL_BUDGET_FIELD: 'total-budget-field',
};

const LINKED_ACCOUNTS = {
    ADD_ACCOUNT_BUTTON: 'add-account-button',
};

const ASSOCIATE_ACCOUNT_MODAL = {
    ASSOCIATE_ACCOUNT_TO_CLIENT_MODAL: 'associate-account-to-client-modal',
};

const INPUTS = {
    OPEN_RANGE_PICKER_WRAPPER: 'open-range-picker-wrapper',
    RANGE_PICKER_WRAPPER: 'range-picker-wrapper',
    EDITABLE_VALUE: 'editable-value',
    ROUNDED_BUTTON_WITH_ARROW: 'rounded-button-with-arrow',
    FULL_SCREEN_BUTTON: 'full-screen-button',
    BUDGET_FIELD: 'budget_field',
    EDIT_CURRENCY_FIELD: 'money-input',
};

const REACT_TABLE = {
    TH_HEADER: 'react-table-th-header',
};

const CAMPAIGNS_TABLE = {
    CAMPAIGN_METRIC_OPTION: 'campaign-metric-option',
    ICON_PENCIL: 'edit-field-icon-pencil',
};

const CHECKBOX = {
    CHECK_BOX_INPUT: 'check-box-input',
};

const OVERVIEW_GAUGE = {
    GAUGE_AVERAGE: 'gauge-average',
};

const ROUNDED_BUTTON = {
    ROUNDED_BUTTON_WITH_ARROW: 'rounded_button_with_arrow',
};

const ACCORDION = {
    ACCORDION_ITEM: 'accordion-item',
    ACCORDION_FIRST_SUB_LABEL: 'accordion-first-sub-label',
    ACCORDION_SECOND_SUB_LABEL: 'accordion-second-sub-label',
};

const SWITCH = {
    SWITCH_INPUT: 'switch-input',
};

const MODAL = {
    CONFIRMATION_MODAL: {
        ID: 'confirmation-modal-id',
        CONTINUE_BUTTON: 'confirmation-modal-continue-button',
        DISMISS_BUTTON: 'confirmation-modal-dismiss-button',
    },
    MODAL_TITLE: 'modal-title',
    LOADING_SKELETON: 'loading-skeleton',
};
const GOAL_HISTORY = {
    GOAL_HISTORY_FEED_ITEM: 'goal-history-feed-item',
    GOAL_HISTORY_CHANGED_FIELD: 'goal-history-changed-field',
    MODAL_TITLE: 'modal-title',
};

const HEADER = {
    HEADER: 'header',
    SHORT_HEADER: 'short-header',
    COMPLETE_HEADER: 'complete-header',
    HEADER_TOP: 'header-top',
    HEADER_BOTTOM: 'header-bottom',
};

/**
 * @deprecated
 * Use component constants to set default tests ids
 */
const TEST_IDS = {
    HISTORY_FEED,
    INPUTS,
    OVERVIEW_GAUGE,
    MANAGE_SETTINGS,
    TIMER_FEED,
    CAMPAIGNS_TABLE,
    REACT_TABLE,
    CHECKBOX,
    LINKED_ACCOUNTS,
    ASSOCIATE_ACCOUNT_MODAL,
    COMPONENTS,
    ROUNDED_BUTTON,
    ACCORDION,
    SWITCH,
    MODAL,
    GOAL_HISTORY,
    HEADER,
};

export default TEST_IDS;
